import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Group = styled.div`
  width: 100%;
  margin: auto;

  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1022px;
  background-color: var(--background-tertiary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  margin-bottom: var(--space-24);
`;

const TableHeader = styled.div`
  ${AlignCenter}
  padding: var(--space-10) var(--space-12);
  gap: var(--space-40);
`;

const TitleWrap = styled.h2`
  width: 100%;
  max-width: 582px;
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const TitleWrapper = styled.h3`
  width: 100%;
  max-width: 165px;
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: var(--space-0);
  border-left: 0.5px solid var(--border-primary);
  padding: var(--space-2) var(--space-0) var(--space-2) var(--space-14);
`;

const TitleWrappers = styled.h4`
  width: 100%;
  max-width: 141px;
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-secondary);
  margin: var(--space-0);
  border-left: 0.5px solid var(--border-primary);
  padding: var(--space-2) var(--space-0) var(--space-2) var(--space-14);
`;

const TableData = styled.div`
  ${FlexBetween}
  padding: var(--space-11) var(--space-12);
  background-color: var(--background-primary);
  border-top: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .more-icon {
    path {
      fill: var(--background-muted);
      stroke: var(--background-muted);
    }
  }
`;

const UserDetails = styled.div`
  width: 100%;
  max-width: 582px;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const UserName = styled.div`
  width: 100px;
  height: 9px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const UserDescription = styled.div`
  width: 120px;
  height: 6px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const UserMail = styled.div`
  width: 80px;
  height: 6px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const UserNumber = styled.div`
  width: 70px;
  height: 6px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const PrivateData = styled.div`
  width: 100%;
  max-width: 290px;
  display: flex;
  justify-content: space-between;
`;

export {
  Group,
  Container,
  TableHeader,
  TitleWrap,
  TitleWrapper,
  TitleWrappers,
  TableData,
  UserDetails,
  UserName,
  UserDescription,
  UserMail,
  UserNumber,
  PrivateData
};
